// export const URL_BACKEND = 'http://localhost:5000/';
// export const URL_FRONTEND = 'http://localhost:5173/artclash/';

export const URL_BACKEND = 'https://ackmi.com:5000/';
export const URL_FRONTEND = 'https://ackmi.com/artclash/';

export const SUB_FOLDER = '/artclash/';//just for react route on server
// export const SUB_FOLDER_NO_F_SLASH = SUB_FOLDER.slice(1, SUB_FOLDER.length);